var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container d-flex align-items-center justify-content-center py-5 py-lg-10"},[_c('div',{staticClass:"loader py-5 py-lg-10"},[_c('div',{staticClass:"loader__item"}),_c('div',{staticClass:"loader__item"}),_c('div',{staticClass:"loader__item"})])])
}]

export { render, staticRenderFns }